import EditComponent from './BrandEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';

//组件 
const WebComponent = (props: any) => {

    /** api服务id */
    const apiId = 'brand';

    //表头
    const columnsHead = [
        {
            title: '品牌英文名',
            dataIndex: 'brandEnglishName'
        },
        {
            title: '品牌名',
            dataIndex: 'brandName'
        },
        {
            title: '商户',
            dataIndex: 'merchant',
            render: (val: any) => val?.merchantName
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '品牌',
        apiId,
        columns,
        showStates: true,
        EditComponent
    };

    return (
        <WebUniversal props={extendProps} />
    )
}

export default WebComponent;
